/* eslint-disable jsx-a11y/label-has-associated-control */
import type { ReactNode } from 'react';
import React from 'react';

import { getDescriptionId, getFeedbackErrorId } from '../../../utils/field';
import type { InputFeedback } from '../Feedback/Feedback';
import { Feedback } from '../Feedback/Feedback';
import * as styles from './FieldWrapper.styles';

export interface FieldWrapperProps {
  $completed?: boolean;
  children: ReactNode;
  description?: string;
  error?: string | null;
  feedback?: InputFeedback;
  fieldId: string;
  label: string;
  labelHidden?: boolean;
}

export const FieldWrapper = ({
  $completed = false,
  children,
  description,
  error,
  feedback,
  fieldId,
  label,
  labelHidden = false,
}: FieldWrapperProps) => {
  return (
    <>
      <label
        css={labelHidden ? styles.labelScreenReaderOnly : styles.label}
        dangerouslySetInnerHTML={{ __html: label }}
        htmlFor={fieldId}
      />
      {description && (
        <p css={styles.description} id={getDescriptionId(fieldId)}>
          {description}
        </p>
      )}
      <div css={styles.wrapper} data-has-error={!!error} data-is-valid={$completed}>
        {children}
        {!error && !feedback ? null : (
          <div css={styles.fieldFeedbackContainer}>
            {!error ? (
              <Feedback iconAlign="left" name={feedback?.name} value={feedback?.value} />
            ) : (
              <Feedback
                error={!!error}
                iconAlign="left"
                id={getFeedbackErrorId(fieldId)}
                name={error}
                value={feedback?.value}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};
